// saveToApi.js
import { getAuthHeader } from './tokenManager';

const apiUrl = process.env.REACT_APP_DJANGO_API_URL;

const SaveToApi = async ({ selectedPayments, selectedContactInfo, selectedSocialMedia, customUrl, account_id, user_id, userDisplay, selectedProducts }) => {
    if (!account_id || !user_id) {
        console.error('account_id and user_id are required');
        return;
    }

    const payments = {};
    const contactInfo = {};
    const socialMedia = {};

    Object.keys(selectedPayments).forEach(key => {
        payments[key] = selectedPayments[key].showInput ? selectedPayments[key].value : null;
    });

    Object.keys(selectedContactInfo).forEach(key => {
        contactInfo[key] = selectedContactInfo[key].showInput ? selectedContactInfo[key].value : null;
    });

    Object.keys(selectedSocialMedia).forEach(key => {
        socialMedia[key] = selectedSocialMedia[key].showInput ? selectedSocialMedia[key].value : null;
    });

    const data = {
        payments,
        contactInfo,
        socialMedia,
        customUrl,
        display_name: userDisplay ? userDisplay : null,
        display_image_url: null,
        displayed_products: selectedProducts || []
    };

    try {
        const response = await fetch(`${apiUrl}/api/${account_id}/update_details/?user_id=${user_id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader(),
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export default SaveToApi;